<template>
  <el-config-provider :locale="locale" :message="config">
    <router-view />
    <ExportDialog v-model:visible="exportVisible" />
    <!--  审批流程详情  -->
    <FlowDeal v-model="flowVisible" v-bind="flowProps" @handleUpdate="flowUpdate" />
    <!-- 导入任务 -->
    <ImportTask v-model:visible="showImportTask" />
    <ContractDetailsDialog v-model="contractVisible" v-bind="contractProps"></ContractDetailsDialog>
    <CityPriceDialog></CityPriceDialog>
  </el-config-provider>
  <!-- 右下角消息弹窗 -->
  <Teleport to="body">
    <Transition name="message-notification-fade">
      <NotifyCom v-if="msgList.length" />
    </Transition>
  </Teleport>

  <div ref="el">
    <RxkDialog
      v-model="dialogFormVisible"
      title="提示"
      width="480"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @closed="handleDialogClose"
    >
      <div class="idle tw-px-[24px] tw-py-[16px]">
        <el-text class="tw-leading-5">
          由于您长时间未操作系统，为保证您的数据安全，已自动冻结页面，请输入系统登录密码解冻页面
        </el-text>
        <el-form :model="formParams" class="tw-mt-3" ref="reLoginRef" @submit.prevent>
          <el-form-item
            label="登录密码"
            prop="password"
            :rules="[
              {
                required: true,
                min: 6,
                max: 18,
                message: '请输入正确的系统登录密码',
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              v-model="formParams.password"
              autocomplete="off"
              type="password"
              placeholder="请输入系统登录密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer tw-px-[24px] tw-py-[16px]">
          <el-button @click="logoutHandler">退出</el-button>
          <el-button type="primary" @click="loginHandler" :loading="loading">确定</el-button>
        </div>
      </template>
    </RxkDialog>
    <CallBackDialog v-model:modelValue="callCenter.showCpsCallRecord"></CallBackDialog>
    <RecordPlayer
      v-model:visible="callCenter.showRecordPlayer"
      :src="callCenter.recordUrl"
      :rowData="callCenter.recordPlayerData"
    ></RecordPlayer>
    <PassWordDialog
      :formData="{
        ...formData,
        mobile: accountStore.userInfo?.mobile,
        username: accountStore.userInfo?.username
      }"
      title="安全提示"
      mobileLabel="手机号"
      :showTip="true"
      :showClose="false"
      :showCancelBtn="false"
      :hideAccount="true"
      confirmBtn="确认修改"
      tipText="您当前密码长时间未更新，存在安全风险，请修改密码"
      v-if="passVisible"
      @success="changePassWordNative"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { ElConfigProvider, FormInstance, ElNotification } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { ExportDialog } from '@/components/business/exportDialog'
import { useExportAndImportStore } from '@/stores/modules/exportAndImport'
import { RxkDialog } from '@/components/common/RxkDialog'
import FlowDeal from '@/components/business/FlowDeal/index.vue'
import { useGlobalFlow } from '@/stores/modules/globalFlow'
import { useVersion } from '@/hooks/useVersion'
import ImportTask from '@/components/business/importFiles/components/upload-logs.vue'
import { useTemCache } from '@/stores/modules/temCache'
import NotifyCom from '@/components/business/notify/index.vue'
import { useSocketMsg } from '@/stores/modules/socketMsg'
import { useCallCenter } from '@/stores/modules/callCenter'
import { callCenterStatusEnum, dialingScenes } from '@/enums/callCenter'
import { createLocalStorage } from './utils/cache'
import { roundCallshutdown } from './apis/callCenter/turnCall'
import { ElMessageBox } from 'element-plus'
import { useAccountStore } from '@/stores/modules/account'
import useRouteCache from '@/hooks/useRouteCache'
import { LoginParams } from './types/user'
import { setToken } from '@/utils/auth'
import { setCache } from '@/utils/cache/local'
import { sleep, getHashParam } from './utils/tools'
import { useOrgInfoStore } from './stores/modules/orgInfo'
import { useGlobalStore } from '@/stores/modules/global'
import ContractDetailsDialog from '@/views/erp/base/contractManage/components/ContractDetailsDialog.vue'
import { useGlobalContract } from '@/stores/modules/globalContract'
import CallBackDialog from '@/views/recycleBin/recycleBinDetail/components/AddVisitRecord.vue'
import { RecordPlayer } from '@/components/business/callCenter/recordPlayer'
import CityPriceDialog from '@/components/business/cityPriceDialog/index.vue'
import { throttle } from 'lodash-es'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import useTracker from '@/hooks/useTracker'
import PassWordDialog from '@/views/accountConfig/components/passWord.vue'
import { useIdle } from '@vueuse/core'
const { idle } = useIdle(20 * 60 * 1000)

const accountStore = useAccountStore()
const reLoginRef = ref<FormInstance>()
const loading = ref(false)
const socketMsg = useSocketMsg()
const orgInfoStore = useOrgInfoStore()
const globalStore = useGlobalStore()
const formParams = ref<LoginParams>({
  clientType: 'TENANT',
  grantType: 'PASSWORD',
  username: '',
  password: '',
  rememberMe: true
})
const config = reactive({
  max: 1
})

const passVisible = computed({
  get() {
    return accountStore?.showPassWordDialog
  },
  set(newVal) {
    accountStore.setShowPassWordDialog(newVal)
  }
})
const formData = reactive({
  userLogo: '',
  realName: '',
  mobile: accountStore.userInfo?.mobile || '',
  username: accountStore.userInfo?.username || '',
  messageNotifyState: ''
})
// 收集路由配置meta为keepAlive: ture的缓存
const { collectCaches } = useRouteCache()
collectCaches()
const temCache = useTemCache()
const showImportTask = ref(false)

const callCenter = useCallCenter()

watch(
  () => temCache.getData('showImportTask'),
  val => {
    console.log(val, '导入导入')
    showImportTask.value = val
  }
)

watch(idle, val => {
  if (val) {
    window.location.reload(true)
  }
})

const dialogFormVisible = computed({
  get() {
    return orgInfoStore.loginVisible
  },
  set(newVal) {
    orgInfoStore.showLoginVisible(newVal)
  }
})
// watch(dialogFormVisible, newVal => newVal && removeToken) // 弹出安全输入提示框就清空之前的token
const useExportAndImport = useExportAndImportStore()
const exportVisible = computed({
  get() {
    return useExportAndImport.exportVisible
  },
  set(newVal) {
    console.log(newVal, 'popopop')
    useExportAndImport.showExportDialog(newVal)
  }
})
const handleDialogClose = async () => {
  reLoginRef.value?.resetFields()
  // 等10s开启重新登录监听
  await sleep(10_000)
  socketMsg.listenAccount()
}
// 流程全局弹框 调起方法globalFlow.init()
const globalFlow = useGlobalFlow()

const flowVisible = computed({
  get() {
    return globalFlow.flowVisible
  },
  set(val) {
    globalFlow.setVisible(val, 'approve')
  }
})

const flowProps = computed(() => {
  return globalFlow.flowOption
})

// 全局合同详情弹框
const globalContract = useGlobalContract()
const contractVisible = computed({
  get() {
    return globalContract.contractVisible
  },
  set(val) {
    globalContract.setVisible(val)
  }
})

const contractProps = computed(() => {
  return globalContract.contractOption
})

/**
 * 系统安全弹窗 取消
 */
const logoutHandler = () => {
  dialogFormVisible.value = false
  localStorage.removeItem('loginTimout')
  accountStore.logout()
}
// 系统安全弹窗 确认
const loginHandler = async () => {
  if (!reLoginRef.value) return
  await reLoginRef.value.validate(async valid => {
    if (valid) {
      try {
        formParams.value.username = accountStore.userInfo?.username
        // 关闭重复登录监听
        socketMsg.closeListenAccount()
        await accountStore.login(formParams.value, false)
        dialogFormVisible.value = false
        localStorage.removeItem('loginTimout')
      } catch (error) {
        /* empty */
      }
    }
  })
}
// 审批状态得改变要刷新列表页
function flowUpdate() {
  globalFlow.setUpdateTime()
}

const locale = ref(zhCn)
const msgList = computed(() => socketMsg.msgList)
if (process.env.NODE_ENV !== 'development') {
  useVersion({})
}
function windowBeforeunLoad(event: any) {
  const callCenter = useCallCenter()
  if (
    callCenter.dialingScenes === dialingScenes.turnCall ||
    callCenter.dialingScenes === dialingScenes.turnCallApp ||
    callCenter.callCenterStatus === callCenterStatusEnum.CALLING
  ) {
    event.preventDefault()
    event.returnValue = '正在通话中, 是否重新加载'
    return '正在通话中, 是否重新加载'
  }
}
function windowUnload() {
  // console.log('windowUnload')
  const callCenter = useCallCenter()
  if (
    callCenter.dialingScenes === dialingScenes.turnCall ||
    callCenter.dialingScenes === dialingScenes.turnCallApp
  ) {
    // TODO 直接请求接口会被浏览器取消，待优化
    createLocalStorage().set('needCloseCallCenter', true)
    createLocalStorage().set('roundCallTaskInfo', callCenter.roundCallTaskInfo)
  }
}

function windowLoad() {
  // console.log('windowLoad', createLocalStorage().get('roundCallTaskInfo'))
  const needCloseCallCenter = createLocalStorage().get('needCloseCallCenter')
  if (needCloseCallCenter && createLocalStorage().get('roundCallTaskInfo')?.taskId) {
    roundCallshutdown({
      taskId: createLocalStorage().get('roundCallTaskInfo').taskId
    })
  }
}

// function destoryCallCenter () {
//   useJsSIP().jssipStop()
//   useDaco().oncloseWS()
// }
let notificationInstance: any = null

function isMobile() {
  // 移动端
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
// 添加缩放检测相关代码
const checkZoom = async () => {
  // 判断是否是移动端
  if (isMobile()) return
  // 检测操作系统类型
  const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform)

  // 获取设备像素比
  const pixelRatio = window.devicePixelRatio

  // 计算实际缩放比例
  // 在macOS的Retina屏幕上，标准pixelRatio为2，所以需要除以2来获取实际缩放比例
  const basePixelRatio = isMac ? 2 : 1
  const zoom = Math.round((pixelRatio / basePixelRatio) * 100)
  if (zoom !== 100) {
    // 如果已存在通知，先关闭它
    if (notificationInstance) {
      await notificationInstance.close()
    }
    notificationInstance = ElNotification({
      title: `你的浏览器处于${zoom}%缩放状态`,
      message: '页面可能会出现错位、功能异常等现象，建议100%大小显示。Ctrl+鼠标滚轮可控制大小',
      type: 'warning',
      onClose: () => {
        notificationInstance = null
      }
    })
  } else {
    notificationInstance?.close?.()
  }
}
const throttledCheckZoom = throttle(checkZoom, 500)
// 内嵌到其他系统
onBeforeMount(() => {
  const token = getHashParam('rxkToken')
  const systemCode = getHashParam('sysCode')
  const frameCode = getHashParam('iframe')
  if (token) {
    setToken('Bearer ' + token)
    setCache('systemCode', systemCode)
    !isNullOrUndefOrEmpty(frameCode) && globalStore.setFrameCode(frameCode)
  }
})

onMounted(() => {
  window.addEventListener('beforeunload', windowBeforeunLoad)
  window.addEventListener('unload', windowUnload)
  window.addEventListener('load', windowLoad)
  checkZoom()
  window.addEventListener('resize', throttledCheckZoom)
  window.addEventListener('visibilitychange', visibleChange)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', windowBeforeunLoad)
  window.removeEventListener('unload', windowUnload)
  window.removeEventListener('load', windowUnload)
  createLocalStorage().remove('needCloseCallCenter')
  createLocalStorage().remove('roundCallTaskInfo')
  window.removeEventListener('resize', throttledCheckZoom)
  window.removeEventListener('visibilitychange', visibleChange)
})
window.addEventListener('storage', e => {
  // 现在同一个浏览器，同时打开两个数融客B端网址，且登录两家机构的账号，数据会相互串掉问题
  if (e.key === 'USER_ID') {
    const localId = localStorage.getItem('USER_ID')
    const id = accountStore.userInfo?.id
    if (localId && id && localId !== id) {
      ElMessageBox.alert('已登录其他账号，当前账号将被退出', '系统提示', {
        showClose: false,
        confirmButtonText: '确定',
        callback: () => {
          window.location.reload()
        }
      })
    }
  }
})

function visibleChange() {
  const { tracker } = useTracker()
  if (document.visibilityState === 'hidden') {
    tracker.sleepStart()
  } else {
    tracker.sleepEnd()
  }
}
const changePassWordNative = () => {
  passVisible.value = false
  logoutHandler()
}
</script>

<style scoped>
.message-notification-fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.message-notification-fade-enter-from,
.message-notification-fade-leave-to {
  transform: translateX(480px);
  opacity: 0;
}
</style>
